import { combineReducers } from 'redux'

import {
  createReducer,
  updateObject,
  createNamedReducer,
  updateFilteredItemInArray,
} from 'helpers/ReducerUtil'
import {
  INPUT_CHANGE,
  DATE_CHANGE,
  INPUT_UI_CHANGE,
  INIT_UI,
} from './constants'
import { getMonthDayYear } from 'helpers/DateUtil'

const initValue = [
  {
    scheduleType: 'Design Review',
    startDate: '',
  },
  {
    scheduleType: 'Qualification',
    startDate: '',
  },
  {
    scheduleType: 'Mass Production',
    startDate: '',
  },
]

const initUiValue = () => {
  const initUi = {}
  initValue.forEach(value => {
    initUi[value.scheduleType] = ''
  })

  return initUi
}

const updateItemInSchedule = (array, label, updateItemCallback) => (
  updateFilteredItemInArray(array, (item) => label === item.scheduleType, updateItemCallback)
)

const getDate = (text) => {
  return text.split('').reduce((result, value, index, array) => {
    if (index % 2 === 0 )
      result.push(array.slice(index, index + 2).join(''))
    return result
  }, []).join('/')
}

const formatDate = (dateInt) => {
  let date = Date.now()
  if (dateInt && dateInt.length === 6 && !(isNaN(Date.parse(dateInt)))){
    date = new Date(getDate(dateInt))
  }
  return date
}

const inputChange = (values, action) => {
  const { label, text } = action
  return updateItemInSchedule(values, label, (item) => {
    const newDate = new Date(formatDate(text))
    return updateObject(item, { startDate: newDate.toString() })
  })
}

const dateChange = (values, action) => {
  const { label, date } = action
  return updateItemInSchedule(values, label, (item) => {
    const newDate = date
    return updateObject(item, { startDate: newDate.toString() })
  })
}

export const scheduleValueReducer = createReducer(initValue, {
  [INPUT_CHANGE]: inputChange,
  [DATE_CHANGE]: dateChange,
})

const initUi = (values, action) => {
  const newValues = {}
  action.value.forEach(value => {
    if (isNaN(Date.parse(value.startDate))) return

    newValues[value.scheduleType] = getMonthDayYear(new Date(`${value.startDate}`)).replace(/\//g, '')
  })

  return newValues
}

const inputUiChange = (values, action) => {
  const { label, text } = action
  return updateObject(values, { [label]: text })
}

const inputUiReducer = createReducer(initUiValue(), {
  [INIT_UI]: initUi,
  [INPUT_UI_CHANGE]: inputUiChange,
})

export const createUiReducer = (uiPath) => {
  return combineReducers({
    inputText: inputUiReducer
  })
}
